
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableFurniture from "vue-material-design-icons/TableFurniture.vue";
import TableApp from "@/components/Table/Table2";
import FilterFields from "@/components/FilterFields";

export default {
  name: "app-restaurante-ambientes",
  components: {
    Pencil,
    TrashCanIcon,
    TableFurniture,
    TableApp,
    FilterFields,
  },
  data() {
    return {
      fields: [
        {
          label: "Nome",
          field: "nome",
          type: "text",
          sortable: true,
          width: "35%",
        },
        {
          label: "Descrição",
          field: "descricao",
          type: "text",
          sortable: false,
          width: "35%",
        },
        {
          label: "Status",
          field: "ativo",
          type: "text",
          sortable: true,
          slot: true,
          width: "15%",
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "15%",
        },
      ],
    };
  },
  methods: {
    excluir(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir o ambiente " + data.nome + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/restaurante/ambientes/delete", {
              id: data.id,
            });

            this.$refs.ambientes.refresh();
            this.$toast.success("Ambiente excluído!");
          }
        });
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
